import { index, show, update, create } from "@/services/clients";
import { destroy } from "../services/clients";

export default {
  namespaced: true,
  state: {
    clients: [],
    loading: false,
    submitting: false,
    totalClients: 0,
    pages: [],
    form: {
      contato1: "",
      contato2: "",
      enderecos: [],
      documento_fiscal: "",
      image_url: "",
      image: null,
      limite_credito_total: 0
    },
    form_loading: false,
    filter: "",
    options: {
      itemsPerPage: 10,
      sortBy: ["nome"],
      sortDesc: [],
      page: 1
    },
    photo_changed: false
  },
  getters: {
    getClients(state) {
      return state.clients;
    },
    getUrlPreview(state) {
      return URL.createObjectURL(state.image_src);
    },
    getImageChanged(state) {
      return state.photo_changed;
    }
  },
  mutations: {
    setImage(state, image) {
      state.image_src = image
    },
    setClients(state, payload = []) {
      state.clients = payload;
    },
    setForm(state, payload = {}) {
      state.form = {
        ...state.form,
        ...payload
      };
    },
    setImageChanged(state, photo_changed) {
      state.photo_changed = photo_changed;
    },
    cleanForm(state) {
      state.form = {
        enderecos: [],
        contato1: "",
        contato2: "",
        documento_fiscal: "",
        limite_credito_total: 0
      };
      state.photo_changed = false;
    },
    setOptions(state, payload) {
      state.options = payload;
    },
    editAddress(state, payload) {
      let endereco = null;

      if (payload.id)
        endereco = state.form.enderecos.find(rec => rec.id == payload.id);
      else endereco = state.form.enderecos[payload.index];

      endereco.cep = payload.cep;
      endereco.estado = payload.estado;
      endereco.cidade = payload.cidade;
      endereco.bairro = payload.bairro;
      endereco.rua = payload.rua;
      endereco.numero = payload.numero;
      endereco.complemento = payload.complemento;
      endereco.uf = payload.uf;
    }
  },
  actions: {
    async indexClients(context) {
      context.state.loading = true;
      context.state.clients = [];

      try {
        const response = await index(
          context.state.options,
          context.state.filter
        );

        context.commit("setClients", response.data);
        context.state.totalClients = response.total;
        context.state.pages.push(response.actual_page);
      } catch (error) {
        context.commit(
          "sendMessage",
          {
            text: error.response.data.message,
            color: "red"
          },
          { root: true }
        );
      } finally {
        context.state.loading = false;
      }
    },
    async showClient(context, id) {
      context.state.form_loading = true;
      context.commit("cleanForm");

      try {
        const response = await show(id);
        context.commit("setForm", response);
      } catch (error) {
        console.log(error);
      } finally {
        context.state.form_loading = false;
      }
    },
    async updateClient(context) {
      context.state.form_loading = true;
      context.state.submitting = true;

      try {
        const response = await update(
          context.state.form.id,
          context.state.form
        );
      } catch (error) {
        throw error
      } finally {
        context.state.form_loading = false;
        context.state.submitting = false;
      }
    },
    async createClient(context) {
      context.state.form_loading = true;
      context.state.submitting = true;

      try {
        const response = await create(context.state.form);
        context.state.form.id = response.id;
      } catch (error) {
        throw error;
      } finally {
        context.state.form_loading = false;
        context.state.submitting = false;
      }
    },
    destroyClient(context, id) {
      return destroy(id);
    },
    async setFilter(context, filter) {
      context.state.filter = filter;
      context.dispatch("indexClients");
    }
  }
};
